import loaderIcon from "../../../images/progress_activity.svg";
import { LoaderContainer } from "../../atoms/Loader/spinner";
import { useTranslation } from "react-i18next";
const Loader = ({loadingText}) => {
   const { t } = useTranslation();
  return (
    <LoaderContainer>
      <img src={loaderIcon} alt={t("Loading")} />
      <span>{loadingText}</span>
    </LoaderContainer>
  );
};
export default Loader;